import { InteractionType, LogLevel as MsalLogLevel, PublicClientApplication } from '@azure/msal-browser';
import type { IPublicClientApplication } from '@azure/msal-browser';
import type { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import type { AppLogLevel } from './app-logging';
import { AppLogging } from './app-logging';
import { AppEnvironment } from './app-environment';

const MSAL_LOG_LEVEL_BY_APP_LOG_LEVEL: Record<AppLogLevel, MsalLogLevel> = {
  error: MsalLogLevel.Error,
  warn: MsalLogLevel.Warning,
  info: MsalLogLevel.Info,
  debug: MsalLogLevel.Verbose,
  trace: MsalLogLevel.Trace,
};

const CONSOLE_METHOD_BY_MSAL_LOG_LEVEL: Record<MsalLogLevel, (...args: unknown[]) => void> = {
  [MsalLogLevel.Error]: console.error.bind(console),
  [MsalLogLevel.Warning]: console.warn.bind(console),
  [MsalLogLevel.Info]: console.info.bind(console),
  [MsalLogLevel.Verbose]: console.debug.bind(console),
  [MsalLogLevel.Trace]: console.debug.bind(console),
};

export function msalInstanceFactory(): IPublicClientApplication {
  const authLogLevel = AppLogging.get('auth');

  return new PublicClientApplication({
    auth: {
      clientId: AppEnvironment.entraClientId,
      authority: `https://login.microsoftonline.com/${AppEnvironment.entraTenantId}`,
      redirectUri: AppEnvironment.entraRedirectUri,
    },
    cache: {
      cacheLocation: 'sessionStorage',
    },
    system: authLogLevel
      ? {
          loggerOptions: {
            loggerCallback: (level, message) =>
              CONSOLE_METHOD_BY_MSAL_LOG_LEVEL[level](`[MSAL] ${message}`),
            logLevel: MSAL_LOG_LEVEL_BY_APP_LOG_LEVEL[authLogLevel],
            piiLoggingEnabled: false,
          },
        }
      : undefined,
  });
}

export function msalGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [AppEnvironment.entraApiScope],
    },
  };
}

export function msalInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(`${AppEnvironment.apiBaseUrl}/*`, [AppEnvironment.entraApiScope]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}
